<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="desserts"
      height="70vh"
      :fixed-header="true"
      :items-per-page="-1"
      :search="search"
      class="elevation-3"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Cadastro de Metas</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>

          <v-spacer></v-spacer>

          <v-text-field
            class="mr-10"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>

          <v-dialog persistent v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn
                small
                rounded
                color="primary"
                dark
                class="mb-2"
                @click="setEquipe()"
                v-on="on"
                >Novo</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.descricao"
                        label="Descrição Meta*"
                        autofocus
                        :error-messages="descricaoErrors"
                        @input="$v.editedItem.descricao.$touch()"
                        @blur="$v.editedItem.descricao.$touch()"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-mask="'######'"
                        v-model="editedItem.meta"
                        label="Meta*"
                        :error-messages="metaErrors"
                        @input="$v.editedItem.meta.$touch()"
                        @blur="$v.editedItem.meta.$touch()"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="pa-0" cols="6" xs="6">
                      <v-select
                        v-model="editedItem.idcandidato"
                        :items="selects.candidatos.items"
                        :disabled="selects.candidatos.ativado"
                        chips
                        label="Equipe"
                        height="10"
                        outlined
                        item-value="idcandidato"
                        item-text="nome_completo"
                        style="margin-right: 5px"
                        :error-messages="equipeErrors"
                        @input="$v.editedItem.idcandidato.$touch()"
                        @blur="$v.editedItem.idcandidato.$touch()"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.src_modulo="{ item }">
        <v-icon>{{ item.src_modulo }}</v-icon>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon title="Editar Candidato" class="mr-2" @click="editItem(item)"
          >mdi-pencil</v-icon
        >
        <v-icon title="Remover Candidato" @click="deleteItem(item)"
          >mdi-delete</v-icon
        >
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import AclAPI from "./../../api/acl";

export default {
  name: "Acl",
  data: () => ({
    dialog: false,
    atualizar: 0,
    search: "",
    headers: [
      {
        text: "ID",
        value: "idmeta",
      },
      {
        text: "Descrição Meta",
        align: "left",
        value: "descricao",
      },
      {
        text: "Meta",
        align: "left",
        value: "meta",
      },
      {
        text: "Equipe",
        align: "left",
        value: "idcandidato",
      },
      {
        text: "Candidato",
        align: "left",
        value: "candidato.nome_completo",
      },
      { text: "Ações", value: "action", sortable: false },
    ],
    desserts: [],
    selects: {
      candidatos: {
        ativado: false,
        items: [],
      },
    },
    editedIndex: -1,
    editedItem: {
      descricao: "",
      meta: "",
      idcandidato: "",
    },
    defaultItem: {
      descricao: "",
      meta: "",
      idcandidato: "",
    },
  }),

  validations: {
    editedItem: {
      descricao: {
        required,
      },
      meta: {
        required,
      },
      idcandidato: {
        required,
      },
    },
  },
  computed: {
    descricaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.descricao.$dirty) return errors;
      !this.$v.editedItem.descricao.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    metaErrors() {
      const errors = [];
      if (!this.$v.editedItem.meta.$dirty) return errors;
      !this.$v.editedItem.meta.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    equipeErrors() {
      const errors = [];
      if (!this.$v.editedItem.idcandidato.$dirty) return errors;
      !this.$v.editedItem.idcandidato.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova Meta" : "Editar Meta";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.desserts = [];
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        AclAPI.getCandidatos(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.selects.candidatos.items = response.data.candidatos;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );

      const equipe = localStorage.getItem("equipe");

      const params = {
        equipe: equipe,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        AclAPI.getMetas(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.desserts = response.data.metas;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover o Meta?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.delMeta(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};

                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação registro possui vínculos!!!");
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.addMeta(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação!!!");
            })
        );

        this.close();
      }
    },
    setEquipe() {
      const equipe = localStorage.getItem("equipe");

      if (equipe != "null") {
        this.editedItem.idcandidato = parseInt(equipe);
        this.selects.candidatos.ativado = true;
      }
    },
  },
};
</script>
<style scoped>
</style>